export const stringMapDefault = {
    ariaLabelButton: "More"
};
